import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Island Dogs (b_87dvl89yd6, advertiser -301834200043748998).
// Lifetime complete-month metrics through Aug 2026.
export const advIslandDogs: FaireAdvertiserProfileEntity = {
  token: "adv_island_dogs",
  type: "advertiserProfile",
  archetype: "new-and-returning",
  displayName: "Island Dogs",
  brandToken: "b_87dvl89yd6",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 35,
  budget: {
    totalBudgetDollars: 2000,
    sharedBudgetDollars: 2000,
    spendingMode: "COMPETITIVE",
    nextRenewsAtDate: "2026-10-01",
    nextBillsAtDate: "2026-10-04",
  },
  overview: {
    numCustomersAcquired: 210,
    numReorderConversions: 51,
    numTotalConversions: 261,
    totalAdsSalesDollars: 111038,
    newCustomerAdsSalesDollars: 92864,
    reorderAdsSalesDollars: 18174,
    totalAdsSpendDollars: 24860,
    newCustomerAdsSpendDollars: 23425,
    reorderAdsSpendDollars: 1435,
    newCustomerBestEstimateFirstYearRoas: 3.35,
    reorderRoas: 12.66,
    combinedFirstYearRoas: 3.88,
    numNewCustomerAdsOrders: 430,
    numReorderAdsOrders: 64,
  },
  availableCredit: { totalRemainingDollars: 0 },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 820,
      maxRecommendedBudgetDollars: 1640,
      isEligibleForIncreaseRec: false,
    },
    reorder: {
      minRecommendedBudgetDollars: 160,
      maxRecommendedBudgetDollars: 320,
      isEligibleForIncreaseRec: false,
    },
  },
  campaignTokens: ["camp_idg_new", "camp_idg_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
